import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LiveAnnouncerService {
  private announcement$ = new Subject<string>();
  private timeoutId: any;

  announce(announcement: string) {
    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    this.announcement$.next(announcement);
    this.timeoutId = setTimeout(() => {
      this.announcement$.next('');
      this.timeoutId = null;
    }, 1000);
  }

  getAnnouncement() {
    return this.announcement$.asObservable();
  }

  // Method to clean up for testing
  clearPendingTimeouts() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
